import { getFullName } from 'utils/users'
import { roleOptions } from '../../../EditAccountModal/components/RoleSelectionSection/constants'

export function getRole(roleId: number): string {
  const currentRole = roleOptions.find(option => roleId === option.value)
  if (currentRole) {
    return currentRole.label
  }

  return 'Basic'
}

export function getName(detail: any): string {
  if (detail?.firstName || detail?.lastName) {
    return getFullName(detail?.firstName, detail?.lastName)
  }

  if (detail?.username) {
    return detail?.username
  }

  if (detail?.email) {
    return detail?.email
  }

  return ''
}
